export const project = 'blast'; // need this for when we dynamically import utils

const getAccessoriesList = (features) => {
	return features.map((feature) => feature.description).join(',');
};

/**
 *
 * @returns A de-duped array of YMM found on the VLP/SRP.
 */
export const vehicleYMMList = ({ vehicles = [] }) => [
	...new Set(
		vehicles.map(
			(vehicle) => `${vehicle.modelYear} ${vehicle.make} ${vehicle.model}`
		)
	)
];

/**
 *
 * @returns An array of YMMT found on the VLP/SRP.
 */
export const vehicleCompareList = ({ vehicles }) => [
	...new Set(
		vehicles.map(
			(vehicle) =>
				`${vehicle.modelYear} ${vehicle.make} ${vehicle.model} ${vehicle.trim}`
		)
	)
];

/**
 *
 * @param eventData eventData object
 * @returns A vehicle information
 */
export const getVehicleArray = ({
	vehicles = [],
	eventData = {},
	window = {}
}) => {
	const singleVehicle = vehicles.length === 1;

	let vehicle = {
		...eventData,
		...window?.DDC?.dataLayer?.page?.trackingTags,
		...eventData.vehicle
	};

	const vin = vehicle.vin || '';
	const vinLookup = vin !== '' && vehicles.length >= 1;

	if (vinLookup || singleVehicle) {
		// For events on vlp/srp take vin and lookup against ddc.vehicle object.
		// Otherwise it's a vdp and take the 0th index.
		vehicle =
			vin !== '' ? vehicles.find((x) => x.vin === vin) : vehicles[0];
	}

	const desiredVehicle = {
		...(vehicle?.features &&
			vehicle.features?.length &&
			vehicle.features.length > 0 && {
				accessories: getAccessoriesList(vehicle.features)
			}),
		...(vehicle?.exteriorColor && {
			color_ext: vehicle.exteriorColor
		}),
		...(vehicle?.interiorColor && {
			color_int: vehicle.interiorColor
		}),
		...(vehicle?.make && { make: vehicle.make }),
		...((vehicle?.modelYear || vehicle?.year) && {
			model_year:
				vehicle?.modelYear?.toString() || vehicle?.year?.toString()
		}),
		...(vehicle?.model && { nameplate: vehicle.model }),
		...(vehicle?.packageCode && {
			package: vehicle.packageCode
		}),
		...(vehicle?.internetPrice && {
			price: vehicle.internetPrice
		}),
		...(vehicle?.trim && { trim: vehicle.trim }),
		...(vehicle?.stockNumber && {
			vehicle_stock_number: vehicle.stockNumber
		}),
		...(vehicle?.vin && { vin: vehicle.vin })
	};

	return Object.keys(desiredVehicle).length > 0 ? [desiredVehicle] : [];
};

const FULLY_QUALIFIED = 'fully qualified';
const PARTIAL_EMAIL = 'partial: email';
const PARTIAL_PHONE = 'partial: phone';

export const CUSTOMER_LEAD_LEVEL = {
	FULLY_QUALIFIED: 'fully qualified',
	PARTIAL_EMAIL: 'partial: email',
	PARTIAL_PHONE: 'partial: phone'
};

// _vehicles indicates to eslint that we are not going to use this argument (even though it will be passed to the function)
export const getCustomerLeadLevel = ({ eventData = {} }) => {
	const {
		streetExists = false,
		firstNameExists = false,
		lastNameExists = false,
		phoneExists = false,
		emailExists = false,
		nameExists = firstNameExists && lastNameExists
	} = eventData;

	let customerLeadLevel;

	if (
		(nameExists && streetExists) ||
		(nameExists && phoneExists && emailExists)
	) {
		customerLeadLevel = FULLY_QUALIFIED;
	} else if (emailExists) {
		customerLeadLevel = PARTIAL_EMAIL;
	} else if (phoneExists) {
		customerLeadLevel = PARTIAL_PHONE;
	}

	return customerLeadLevel;
};

export const calculateVideoViewTime = ({ eventData }) => {
	return (
		parseFloat(eventData.videoDuration) * (eventData.videoMilestone / 100)
	);
};
